// extracted by mini-css-extract-plugin
module.exports = {"advancedContent":"styles_advancedContent__fsCda","fieldset":"styles_fieldset__fu69X","legend":"styles_legend__1cTMe"};